<form [formGroup]="form">
  <p-multiSelect #select class="w-full" styleClass="w-full" [options]="options" formControlName="staff"
    appendTo="body" [filter]="true" display="chip" filterBy="first, last, nickname" (onChange)="valueChange()"
    (onBlur)="onInputBlur()" [virtualScroll]="virtualScroll()" [virtualScrollItemSize]="virtualScrollItemSize()"
    [resetFilterOnHide]="true" [autofocusFilter]="true" [loading]="loading()">
    <ng-template pTemplate="selectedItems">
      @if (!value || value.length === 0) {
        <div class="p-dropdown-label-empty">empty</div>
      }
      @for (option of value; track option) {
        <p-tag>{{option | staffDisplay}} @if (!disabled) {<fa-icon class="p-tag-icon-right"
        [icon]="icons.solid.faCircleXmark" (click)="removeItem(option)"></fa-icon>}</p-tag>
      }
    </ng-template>
    <ng-template let-staff pTemplate="item">
      {{staff | staffDisplay}}
    </ng-template>
  </p-multiSelect>
</form>